// extracted by mini-css-extract-plugin
export var lg = "_3s-4";
export var md = "_3s-3";
export var sm = "_3s-2";
export var xs = "_3s-1";
export var xxs = "_3s-0";